<template>
    <div class="profile">
        <div class="hero is-danger">
        <div class="container intro">
            <div class="text-content">
                 <h1 class="title">Karen Efereyan</h1>
                 <h3 class="subtitle">Mid level athlete</h3>
            </div>
               <img src="../assets/pic3.jpg" alt="">
        </div>
        </div>
        <div class="buttons are-normal are-centered">
            <button class="button is-info">Sun</button>
            <button class="button is-success">Mon</button>
            <button class="button is-warning">Tue</button>
            <button class="button is-danger">Wed</button>
             <button class="button is-info">Thur</button>
              <button class="button is-success">Fri</button>
</div>
<div class="tile">
    <div class="container tiledCont">
         <span class="steps">Steps</span>
    <span class="stepsNo">2299</span>
    <span class="stepsWalked">You walked 229mins today</span>
    <progress class="progress is-danger mx-auto" value="70" max="100">70%</progress>
    </div> 
</div>
<div class="columns">
    <div class="container">
    <div class="column">
        <div class="desc">
            <h3>Distance</h3>
        </div>
        <div class="stat">
            <h1>4390<span>m</span></h1>
        </div>
    </div>
     <div class="column">
        <div class="desc">
            <h3>Calories</h3>
        </div>
        <div class="stat">
            <h1>8590<span>ca</span></h1>
        </div>
    </div>
     <div class="column">
        <div class="desc">
            <h3>Point</h3>
        </div>
        <div class="stat">
            <h1>10900<span>p</span></h1>
        </div>
    </div>
    </div>
</div>
    </div>
</template>


<script>
export default {
    name : 'Profile',
    components : {

    }
}
</script>


<style lang="scss" scoped>
.main{
    background-color:red;
}
.intro{
    padding-top: 5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.profile img{
    width:150px;
    height: 150px;
    border-radius:50%;
}
.text-content{
    padding:3rem .75;
    font-family: 'Times New Roman', Times, serif;
    text-align: justify;
}
.text-content .title{
    font-size:2.5rem;
    font-weight: bold;
}
.text-content .subtitle{
    font-size:.95rem;
}
.buttons{
    padding-top:.5rem;
    display:flex;
    justify-content: center;
    align-items:center;
}
.tiledCont{
    display:flex;
    flex-direction: column!important;
    align-items:flex-end;
    padding: 0 1.5rem;
}
.steps{
    color:#c9c9c9;
    font-size:.85rem;
}
.stepsNo{
    font-size:4rem;
}
.stepsWalked{
    font-size:1.15rem;
    font-weight: 700;
    margin-bottom:2rem;
}
.columns{
    margin-top:2rem;
}
.columns .column{
    display:flex;
    justify-content: space-between;
    align-items:center;
}
.desc h3{
    color:darkslateblue;
    font-weight:300;
    font-size:.95rem;
}
.stat h1{
    color:darkslateblue;
    font-weight:bold;
    font-size:1.2rem;
}
.stat h1 span{
    font-size: .95rem;
    color:darkslateblue;
    font-weight:200;
    padding-left:.5rem;
}
@media only screen and (max-width:768px){
    .buttons{
        display: flex;
        flex-wrap:nowrap;
        overflow-x:hidden;
    }
    .columns .column{
        padding: 1rem 1.1rem;
    }
}
</style>